<template>
  <q-page>
    <div v-if="$apollo.loading">Loading...</div>
    <q-table v-else title="Vouchers" :columns="columns" :data="vouchers" :pagination.sync="pagination" flat :filter="filter" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body-cell-expired="props">
        <q-td key="verified" :props="props">
          <q-checkbox disabled :value="!!props.value"></q-checkbox>
        </q-td>
      </template>
      <template v-slot:body-cell-voucherCode="props">
        <q-td :props="props">
          <slot name="group" v-bind:row="props.row">
            <router-link :to="`/admin/vouchers/${props.row.id}`">
              ********
            </router-link>
          </slot>
        </q-td>
      </template>
<!--      <template v-slot:body="props">-->
<!--        <q-tr :props="props">-->
<!--          <q-td key="verified" :props="props">-->
<!--            <q-checkbox disabled :value="!!props.row.verifiedAt"></q-checkbox>-->
<!--          </q-td>-->
<!--          <q-td key="value" :props="props"><router-link :to="`/admin/vouchers/${props.row.id}`">{{props.row.companyName}}</router-link></q-td>-->
<!--          <q-td key="expiresAt" :props="props">{{props.row.contactName}}</q-td>-->
<!--          <q-td key="createdAt" :props="props">{{props.row.email}}</q-td>-->
<!--          <q-td key="timesUsed" :props="props">{{props.row.contactPhone}}</q-td>-->
<!--          <q-td key="expired" :props="props">{{props.row.shippingAddress}}</q-td>-->
<!--          <q-td key="created" :props="props">{{fromNow(props.row.createdAt)}}</q-td>-->
<!--          <q-td key="lastLogin" :props="props">{{fromNow(props.row.lastLogin)}}</q-td>-->
<!--          <q-td key="actions" :props="props">-->
<!--            <q-btn dense flat icon="edit" size="sm" :to="`/admin/vouchers/${props.row.id}`"></q-btn>-->
<!--            <q-btn dense flat icon="delete" size="sm" @click="deleteAccount(props.row)"></q-btn>-->
<!--          </q-td>-->
<!--        </q-tr>-->
<!--      </template>-->
    </q-table>
    <q-btn flat color="primary" class="q-ma-md full-width q-px-md" @click="addNewVoucher">Create Voucher</q-btn>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminAccounts',
  apollo: {
    vouchers: {
      query: gql`
        query {
          vouchers {
            id,
            voucherCode,
            dollarValue,
            percentValue,
            expiresAt,
            timesUsed,
            expired,
            #createdAt,
            #verifiedAt
          }
        }
      `,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return 'Unknown'
      return moment(t).fromNow()
    },
    async addNewVoucher () {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation addVoucher($input: VoucherInput!) {
                addVoucher (input: $input) {
                    id
                }
            }
          `,
          variables: {
            input: {}
          }
        })
        if (!response.data.addVoucher) throw Error('Could not create voucher.')
        this.$router.push(`/admin/vouchers/${response.data.addVoucher.id}`)
      } catch (ex) {
        this.$q.notify({
          message: ex.message,
          color: 'negative',
          icon: 'report_problem'
        })
      }
    }
  },
  data () {
    return {
      filter: '',
      columns: [
        { name: 'expired', align: 'left', required: true, label: 'Expired', field: 'expired', sortable: true },
        { name: 'voucherCode', align: 'left', required: true, label: 'Code', field: 'voucherCode', sortable: true },
        {
          name: 'value',
          align: 'left',
          required: true,
          label: 'Value',
          field: row => row,
          format: v => `${v.percentValue ? v.percentValue.toFixed(0) + '%' : ''}${v.dollarValue ? '$' + v.dollarValue.toFixed(2) : ''}` || 'Nil',
          sortable: true
        },
        { name: 'expiresAt', align: 'left', required: true, label: 'Expires', field: 'expiresAt', format: this.fromNow, sortable: true },
      ],
      pagination: {
        rowsPerPage: 20
      }
    }
  }
}
</script>
